// @core/api/endpoints/chat/get_or_create_direct_conversation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConversationResponse,
  GetOrCreateDirectConversationRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Get or create direct conversation with user
 * Returns an existing direct message conversation with the specified user, or creates a new one if none exists. Ensures only one DM conversation exists between any two users.
 */
export async function GetOrCreateDirectConversation(
  data: GetOrCreateDirectConversationRequest,
  options?: RequestOptions
): Promise<ConversationResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/conversations/direct`;
  const requestOptions = options;
  return client.post<ConversationResponse>(requestPath, data, requestOptions);
}
